import React from "react";
import classNames from "classnames";
const ButtonBar = props => {
    const className = classNames("gui-buttonBar", `gui-buttonBar--${props.align || "left"}`, `gui-buttonBar--valign-${props.valign || "top"}`);
    return (React.createElement("div", { className: className }, React.Children.map(props.children, (content, idx) => content !== null ? (React.createElement("div", { className: "gui-buttonBar__item", key: idx }, content)) : null)));
};
export default ButtonBar;
//# sourceMappingURL=ButtonBar.js.map